<template>

    <div class="flex bg-white dark:bg-[#22272e]">
        <div class="w-[265px] z-10 bg-white sticky top-[69px] h-full dark:bg-[#22272e]">
            <CalendarFilters ref="calendarFilters"
                             :calendars_list_json="calendars_list_json"
                             @filterChanged="fetchCalendarData"
                             :host="host"></CalendarFilters>
        </div>
        <div :class="{ '-ml-6' : calendar_settings.display_secondary_time_zone == false && calendar_settings.default_view !='month' }" class="w-full relative flex-grow h-screen-80px overflow-y-auto scrollbar-style">
            <MyCalendar ref="myCalendar"
                        :calendar_settings="calendar_settings"
                        :host="host"></MyCalendar>
        </div>
    </div>
  
</template>

<script>
import MyCalendar from "controllers/vue_components/calendar/my_calendar"
import CalendarFilters from "controllers/vue_components/calendar/filters"
import RequestMixin from "controllers/vue_components/mixins/request"
import Constants from "controllers/vue_components/mixins/constants"
import Formatting from "controllers/vue_components/mixins/formatting"
import { useCalendarStore } from 'controllers/vue_components/calendar/store'

export default {
    name: 'Index',
    components: {
        MyCalendar, CalendarFilters
    },
    mixins: [RequestMixin, Constants, Formatting],
    props: ['host', 'calendar_settings_json', 'calendars_list_json', 'views_list_json', 'days_list_json'],
    data() {
        return {
            calendar_settings: {},
            data: {},
            calendars: [],
            events_by_id: {},
            events: [],
            fetched_events_start_at: null,
            fetched_events_end_at: null,
            color_changed: false
        };
    },
    methods: {
        useCalendarStoreObj() {
            return useCalendarStore();
        },

        setEvents() {
            this.events = Object.values(this.events_by_id);
        },

        async fetchCalendarData(filterData) {
            let fetch_data = true
            if(this.fetched_events_start_at !== null) {
                if(filterData.bookings_start_at >= this.fetched_events_start_at && filterData.bookings_end_at <= this.fetched_events_end_at) {
                    fetch_data = false
                } else {
                    if (filterData.bookings_start_at >= this.fetched_events_start_at && filterData.bookings_start_at <= this.fetched_events_end_at) {
                        filterData.bookings_start_at =  this.fetched_events_end_at
                    }

                    if (filterData.bookings_start_at >= this.fetched_events_end_at ) {
                        filterData.bookings_start_at =  this.fetched_events_end_at
                    }

                    if (filterData.bookings_end_at >= this.fetched_events_start_at && filterData.bookings_end_at <= this.fetched_events_end_at) {
                        filterData.bookings_end_at = this.fetched_events_start_at
                    }
                }
            }
            if (filterData.color_changed != this.color_changed) {
                fetch_data = true
            }


            if (this.fetched_events_start_at === null) {
                this.fetched_events_start_at = filterData.bookings_start_at
                this.fetched_events_end_at = filterData.bookings_end_at
            } else {
                if(filterData.bookings_start_at < this.fetched_events_start_at) {
                    this.fetched_events_start_at = filterData.bookings_start_at
                }

                if(filterData.bookings_end_at > this.fetched_events_end_at) {
                    this.fetched_events_end_at = filterData.bookings_end_at
                }
            }

            if(fetch_data) {
                let response = await this.axiosRequest('GET', '/api/v1/calendar/bookings', filterData, false)
                if (response.js_error == false && response.response.success) {
                    let bookings = response.response.data.bookings

                    for(let i = 0; i < bookings.length; i++) {
                        this.events_by_id[bookings[i].id] = bookings[i]
                    }
                    this.setEvents();
                    this.$refs.calendarFilters.receiveDataFromHome(response.response.data);
                }
            }

            this.$refs.myCalendar.updateData({
                events_by_id: this.events_by_id,
                events: this.events
            }, filterData);
        },

        async fetchHostEvents() {
            console.log('fetching host events')
            let response = await this.axiosRequest('GET', '/api/v1/events', {}, false)
            if(response.js_error == false && response.response.success) {
                this.useCalendarStoreObj().host_events = response.response.data;
                const eventsData = response.response.data.map(event => ({
                    color: event.color,
                    key: event.id,
                    value: event.name
                }));

                this.useCalendarStoreObj().events = [
                    { key: 'all_events', value: this.I18N.features.bookings.all_events },
                    ...eventsData,
                    { key: 'none', value: this.I18N.features.bookings.none }
                ];
            }
        },
    },
    created() {
        this.calendar_settings = JSON.parse(this.calendar_settings_json);
        this.calendars = JSON.parse(this.calendars_list_json);
        this.useCalendarStoreObj().calendars_list = JSON.parse(this.calendars_list_json);
        this.useCalendarStoreObj().setCalendarSettings(this.calendar_settings);
        this.useCalendarStoreObj().setViewsList(JSON.parse(this.views_list_json));
        this.useCalendarStoreObj().days_list = JSON.parse(this.days_list_json);
        this.fetchHostEvents();
    }
};
</script>
